<template>
    <v-card :class="[ hasSystemMessage ? 'news-card-banner panelBlock' : 'news-card-no-banner panelBlock', routeConfigHideHeader && 'no-header-layout']">
        <v-layout class="news-layout relative-position" row wrap>
            <v-btn  flat
                    fab
                    small
                    @click="editNews"
                    data-qe-id="edit_news-feed_button"
                    color="ypo_blue"
                    class="news-layout__edit-btn"
                    :class="[ this.primaryNews.isDarkTheme ? 'dark-theme__edit-button-color' : '']"
                    v-if="displayNewsEditorBtn">
                <v-icon>edit</v-icon>
            </v-btn>
            <v-flex class="hero-layout--wrapper">
                <v-layout class="hero-layout flex-grow-overwrite-all relative-position"
                          pa-3
                          column
                          v-if="primaryNews"
                          @click="openNews(primaryNews)"
                          :style="heroBackgroundImage">
                    <v-flex :class="[ this.primaryNews.isDarkTheme ? 'dark-theme__text-color' : 'hero-layout__text-color']">
                        <v-flex class="hero-layout__title" pb-3 >{{this.primaryNews.title}}</v-flex>
                        <v-flex class="hero-layout__body">{{this.primaryNews.body}}</v-flex>
                    </v-flex>
                    <v-btn v-if="this.primaryNews.showButton"
                           class="hero-layout__button"
                           :class="[ this.primaryNews.isDarkTheme ? 'dark-theme__button-color' : 'hero-layout__button-color']">
                        {{this.primaryNews.buttonText}}
                    </v-btn>
                </v-layout>
            </v-flex>
            <v-flex class="secondary-layout--wrapper">
                <v-layout class="secondary-layout" column v-if="secondaryNews">
                    <v-flex class="secondary-layout__item"
                            pa-3
                            @click="openNews(newsItem)"
                            v-for="(newsItem, index) in this.secondaryNews"
                            :key="index.id">
                        <v-layout column>
                            <v-flex class="secondary-layout__title">{{newsItem.title}}</v-flex>
                            <v-flex pt-2 pb-2 class="secondary-layout__link">{{newsItem.urltext}}</v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card>

</template>

<script>

    import { mapGetters } from "vuex";
    import { storeGetters } from "@/store/storeGetters.constant";
    import { newsFeedConstant } from "./newsFeed.constant";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

    export default {
        name: 'NewsFeed',
        props: {
            newsFeed: {
                type: Object,
                required: true,
            },
            toggleNewsEditor: {
                type: Function,
            },
            previewMode: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            if (this.newsFeed && this.newsFeed.newsList && this.newsFeed.newsList.length) {
                this.primaryNews = this.newsFeed.newsList.find(news => news.isPrimary);
                this.secondaryNews = this.newsFeed.newsList.filter(news => !news.isPrimary);
            }
        },
        data: () => ({
            secondaryNews: null,
            primaryNews: null,
            newsFeedConstant,
        }),
        methods: {
            editNews() {
                if (this.toggleNewsEditor) this.toggleNewsEditor();
            },
            openNews(news) {
                if (news) {
                    if (news.emailUrl) {
                        window.location.href = `mailto:${news.emailUrl}?subject=${news.title}`;
                      gaDataLayerEvent(gtmEventName.C_Featured_News, news.emailUrl);
                    } else if (news.url) {
                        window.open(news.url, this.isMobileAppBrowser ? '_self' : '_blank');
                      gaDataLayerEvent(gtmEventName.C_Featured_News, news.url);
                    }
                }
            },
        },
        computed: {
            ...mapGetters({
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                systemMessages: `notification/${storeGetters.systemMessages}`,
                routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
                routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
            }),
            heroBackgroundImage() {
                return this.primaryNews && this.primaryNews.featuredNewsImage && this.primaryNews.featuredNewsImage.url
                    ? { backgroundImage: `url(${sizeFormattedImageUrl(this.primaryNews.featuredNewsImage.url, 400, 800)})` }
                    : {};
            },
            displayNewsEditorBtn() {
                return !this.displayNewsEditor && this.newsFeed && this.newsFeed.canEdit && this.toggleNewsEditor;
            },

            hasSystemMessage() {
                return this.systemMessages && this.systemMessages.length && !this.routeConfigEngagementApp;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import "../../common/styles/_responsive.scss";

    .dark-theme {

        &__text-color {
            color: $white !important;
        }

        &__button-color {
            color: $black !important;
            background-color: $white !important;
        }

        &__edit-button-color {
            i {
                @include breakpoint(xs) {
                    color: $white !important;
                }
            }
        }
    }


    .news-card-banner {
        @include breakpoint(xs) {
            margin-top: 65px;
        }
    }

    .news-card-no-banner {
        @include breakpoint(xs) {
            margin-top: 0;
        }
    }

    .news-layout{
        word-break: break-word;

        &__edit-btn {
            z-index: 8;
            height: 28px;
            width: 28px;
            position: absolute;
            right: 0;
            top: 0;
            margin: 0;

            i {
                font-size: 16px !important;
            }
        }
    }

    .hero-layout{
        @include breakpoint(xs) {
            max-height: 200px;
            min-height: 174px;
        }
        font-family: "Raleway", sans-serif;
        padding: 15px 8px 8px 15px;
        height: 100%;
        cursor: pointer;
        border-bottom: 1px solid $ypo-medium-gray;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        &--wrapper {
            flex-basis: 63%;
            max-width: 63%;

            @include breakpoint(xs) {
                flex-basis: 100%;
                max-width: 100%;
            }
        }

        &__text-color{
            color: $black;
        }

        &__title {
            font-size: 24px;
            letter-spacing: 0.44px;
            line-height: 30px;
            min-height: 44px;
            font-weight: 600;

            @include breakpoint(md) {
                min-height: 38px;
            }

            @include breakpoint(xs) {
                font-size: 16px;
                letter-spacing: 0.3px;
                line-height: 19px;
                min-height: 30px;
            }
        }

        &__body {
            font-size: 14px;
            letter-spacing: 0.26px;
            line-height: 18px;

            @include breakpoint(xs) {
                font-size: 11px;
                font-weight: normal;
                letter-spacing: 0.2px;
                line-height: 14px;
            }
        }

        &__button {
            font-weight: 600;
            height: 40px;
            font-size: 14px;
            border-radius: 4px;
            letter-spacing: 0.26px;
            line-height: 16px;
            position: absolute;
            bottom: 20px;
            margin: 0;

            @include breakpoint(xs) {
                font-size: 12px;
            }
        }

        &__button-color {
            background-color: $ypo-blue !important;
            color: $white !important;
        }
    }

    .secondary-layout {
        border-left: 1px solid $ypo-medium-gray;

        &--wrapper {
            flex-basis: 37%;
            max-width: 37%;

            @include breakpoint(xs) {
                flex-basis: 100%;
                max-width: 100%;
            }
        }

        &__item {
            border-bottom: 1px solid $ypo-medium-gray;
            cursor: pointer;
        }

        &__title {
            font-family: "Raleway", sans-serif;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.26px;
            line-height: 18px;
        }

        &__link {
            text-decoration: underline;
            color: $ypo-cta;
            font-family: "Noto Sans", sans-serif;
            font-size: 13px;
            letter-spacing: 0.24px;
            line-height: 14px;

        }

        :nth-child(3n) {
            border: none;
        }
    }

    .heroTitleMargin{
        @include breakpoint(xs) {
            margin-right: 40px;
        }
    }

</style>
